import { Component, Inject, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription} from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LogoService } from '../../services/logo.service';
import { r3JitTypeSourceSpan, ThrowStmt } from '@angular/compiler';
import { NotesEditComponent } from '../notes-edit/notes-edit.component';
import { NoteService } from "../../services/note.service";
import { EntityService } from '../../services/entity.service';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faPlusCircle, faCheck, faEdit, faTimes, faTrashAlt, faCheckCircle, faSave, faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import E from 'wangeditor';
import i18next from 'i18next';
import { UserService } from '../../services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';

const moment = _rollupMoment || _moment;
const MONTH_YEAR_FORMAT = 'YYYY-MM';
const FORMAT = `${MONTH_YEAR_FORMAT}-DD`;
const DATE_FORMATS = {
  parse: {
    dateInput: FORMAT,
  },
  display: {
    dateInput: FORMAT,
    monthYearLabel: MONTH_YEAR_FORMAT,
    dateA11yLabel: FORMAT,
    monthYearA11yLabel: MONTH_YEAR_FORMAT,
  },
};

const TOGGLE_ICON = `
  <svg t="1629193396672" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2716" width="50" height="50"><path d="M887.467 597.333c25.6 0 42.666 29.867 25.6 51.2L908.8 652.8 733.867 827.733c-12.8 12.8-34.134 12.8-46.934 0-12.8-12.8-12.8-29.866-4.266-42.666l4.266-4.267L806.4 661.333H115.2c-17.067 0-29.867-12.8-29.867-25.6v-4.266c0-17.067 12.8-29.867 25.6-29.867h776.534z m-576-418.133c12.8 12.8 12.8 29.867 4.266 42.667l-4.266 4.266-115.2 119.467h691.2c17.066 0 29.866 12.8 29.866 25.6v4.267c0 17.066-12.8 29.866-25.6 29.866H119.467c-25.6 0-42.667-29.866-25.6-51.2l4.266-4.266 174.934-174.934c8.533-8.533 25.6-8.533 38.4 4.267z" p-id="2717"></path></svg>
`;

@Component({
  selector: 'app-entity-edit',
  templateUrl: './entity-edit.component.html',
  styleUrls: ['./entity-edit.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: DATE_FORMATS
    },
  ],
})
export class EntityEditComponent implements OnInit, OnDestroy {

  private user$: Subscription;
  private logosData$: Subscription;
  logosData:any;

  oldLayoutAreas = ["bps","bpaas","insurance","devices","collaboration", 'asset', "engineering","analytics","data","managedapp","enterpriseapp","modernization","iaas","paas", 'hybrid', "server","mainframe","storage","datacenter","network","security","systemsupport", 'consulting', 'analysts'];
  newLayoutAreas = ["bps","bpaas","insurance", 'consulting', 'analysts', "engineering","analytics","data","managedapp","enterpriseapp","modernization","iaas","paas", 'hybrid', "server","mainframe","storage", 'devices', 'collaboration', 'asset', "network","systemsupport","security", 'datacenter'];
  statuses = ["Existing Business","Potential Growth","Not Engaged", "Unknown Status"];

  healthStatuses = ["Healthy","Borderline","Critical Improvement Needed","Strategic Growth Program", "Unknown Status"];
  healthTrends = ["Will Improve","Will Maintain Healthy","Will Degrade","Is Actively Degrading", 'Unknown Status']
  isLoading = false;

  originalArea = "";
  originalDisplayOrder = 0;
  displayorderList = [];
  entitiesData = [];
  // landscapeNote='';
  // landscapeNoteCreatedOn="";
  // healthViewNote='';
  // healthViewNoteCreatedOn="";
  // accountNote='';
  // accountNoteCreatedOn="";
  landscapeViews=[];
  healthViews=[];
  generalViews=[];
  healthView=[];
  landscapeView=[];
  allViews=[];
  selectedViews=[];
  addData = {};
  editor: any;
  editor1: any;
  slNewNote: "";
  hvNewNote: "";
  geNewNote: "";
  slNewNoteDisplay: boolean = false;
  hvNewNoteDisplay: boolean = false;
  geNewNoteDisplay: boolean = false;
  slSelected: boolean = true;
  hvSelected: boolean = true;
  geSelected: boolean = true;
  user: any;
  enableYearLostPicker: boolean = false;
  yearslostNum = '';
  yearslost = '';
  enableTenurePicker: boolean = false;
  servicetenureNum = '';
  servicetenure = '';
  maxYearDiff = 99;
  useNewLayout = false;
  constructor(
    public logoService: LogoService,
    public noteService:NoteService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EntityEditComponent>,   
    public userService: UserService,   
    private snackBar: MatSnackBar,
    library: FaIconLibrary,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public entityService: EntityService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) { 
      library.addIcons(faPlusCircle, faCheck, faEdit, faTimes, faTrashAlt, faCheckCircle, faSave, faTimesCircle);
      this.iconRegistry.addSvgIconLiteral('toggle-icon', this.sanitizer.bypassSecurityTrustHtml(TOGGLE_ICON));
    }

  ngOnInit(): void {
    this.yearslostNum = this.data.yearslostNum;
    this.yearslost = this.data.yearslost;
    this.servicetenureNum = this.data.servicetenureNum;
    this.servicetenure = this.data.servicetenure;

    this.useNewLayout = this.data.useNewLayout;

    this.user$ = this.userService.user$.subscribe(data => {           
      if (data != null) {
        this.user = data[0];
      } else {
        this.user = {id:"",username:"",initials:""}
      }
    })

        // wire up the logos - this will get loaded by the main page
        // so aren't doing for every entity
        this.logosData$ = this.logoService.logos$.subscribe(
          (responsedata: any) => {
            if(responsedata!=null){                  
              if(responsedata.loading){
              } else {            
                this.logosData = this.deepCopyArray(responsedata["data"]);      
                this.logosData.unshift({name:"client",file:"client",company:""})

                // find the logo with name "dxc" and add that to the top
                let dxclogo = "dxc.png"
                this.logosData.forEach(x => {
                  if(x["name"].toLowerCase()=="dxc"){
                      dxclogo = x.file
                  }
                });
                this.logosData.unshift({name:"dxc",file:dxclogo,company:""})
              }          
            }
          }
        )

        // sort out the order stuff         
        // remember the original values
        this.originalArea = this.data["area"];
        this.originalDisplayOrder = this.data["displayorder"];
        this.data["originalDisplayOrder"] = this.originalDisplayOrder;
        // gen the drop down list of choices
        this.getOrderList();

        this.noteService.loadNotes(this.data.id,this.data.versionid,'S');
        this.noteService.healthView$.subscribe((responsedata:any) => {
          console.log(responsedata);
            if(responsedata!=null){
              if(responsedata.loading){
                this.isLoading = true;
              } else {
                this.isLoading = false;
                this.healthView = responsedata["data"]||[];
               }
            }
        })
        this.noteService.landscapeView$.subscribe((responsedata:any) => {
          console.log(responsedata);
            if(responsedata!=null){
              if(responsedata.loading){
                this.isLoading = true;
              } else {
                this.isLoading = false;
                this.landscapeView = responsedata["data"]||[];
               }
            }
        })

        this.noteService.allView$.subscribe((responsedata:any) => {
          console.log(responsedata);
            if(responsedata!=null){
              if(responsedata.loading){
                this.isLoading = true;
              } else {
                this.isLoading = false;
                if(responsedata["data"]){
                  this.allViews = responsedata["data"].filter(x => (['landscape', 'health'].indexOf(x.notetype)!=-1));
                  this.selectedViews = this.allViews;
                  this.generalViews = responsedata["data"].filter(x => (x.notetype=='general'));
                  this.healthViews = responsedata["data"].filter(x => (x.notetype=='health'));
                  this.landscapeViews = responsedata["data"].filter(x => (x.notetype=='landscape'));
                }
               }
            }
        })
  }

  ngOnDestroy(): void {
    this.user$.unsubscribe();
    this.logosData$.unsubscribe();
  }

  getOrderList() {
    let rtn = [];
    if (this.data["areaCounts"] == null) {
      rtn.push(1)
    } else if (this.data["areaCounts"][this.data["area"]] == null) {
      rtn.push(1)
    } else {
      let cnt = this.data["areaCounts"][this.data["area"]]
      // if this is an add or an add to the area then add an extra one
      if(this["id"]=="" || this.data["area"]!=this.originalArea) cnt++;
      for (let i = 0; i < cnt; i++) {
        rtn.push(i + 1);
      }
    }
    this.displayorderList = rtn;
  }

  updateDisplayOrder(){
    
    this.getOrderList();

    let endorder = 1;
    if(this.data["areaCounts"]!=null && this.data["areaCounts"][this.data["area"]]!=null){
      if(this.data["area"]==this.originalArea){
        // put it where it was
        endorder = this.originalDisplayOrder;
      } else {
        // put it at the end
        endorder = this.data["areaCounts"][this.data["area"]] + 1;
      }      
    }
    this.data["displayorder"] = endorder;
  }

  close(){
    this.dialogRef.close("cancel");
  }                                                                                                                                                                                                                                                                                                                                                                          
  formatNum(data,key){
    if(data[key].indexOf('0') == 0 && data[key].length>1){
      data[key]= data[key].substring(1,data[key].length);
    }
  }
  delete(){
    const dialogRef = this.dialog.open(OKCancelDialog, {
      width: '350px',
      data: {title:"Confirm", text: "Do you want to delete this entity from the view?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result=="ok"){
        this.dialogRef.close("delete");
      }      
    });
  }
  openNotes(tab){
    let dialogRef = this.dialog.open(NotesEditComponent, {
      height: '600px',
      width: '700px',
      data: ""
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result=="cancel") return;
      else if(result!==undefined){
        let notetype = '';
        if(tab=='landscape'){
          //this.landscapeView[0].comment = result;
          notetype = 'landscape';
        }else if(tab=='healthView'){
          //this.healthView[0].comment = result;
          notetype = 'health';
        }else if(tab=='general'){
          notetype = 'general';
        }
        this.addData = {
          'id':0, //(- 新增 ，其他数字为修改)
          'entityid': this.data.id,
          'versionid': this.data.versionid,
          'notetype': notetype,
          'comment': result
        };
        this.noteService.updateNotes(this.addData);
      }
    })
  }
  saveNote(tab){
    if(!this.data.id){
      this.save(tab);
    }else{
      let notetype = '';
    let comment = '';
    if(tab=='landscape'){
      notetype = 'landscape';
      comment = this.slNewNote;
    }else if(tab=='healthView'){
      notetype = 'health';
      comment = this.hvNewNote;
    }else if(tab=='general'){
      notetype = 'general';
      comment = this.geNewNote;
    }
    if(comment ==""){
      let message="The empty note could not be saved."
      let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
    }else{
      this.addData = {
        'id':0, //(- 新增 ，其他数字为修改)
        'entityid': this.data.id,
        'versionid': this.data.versionid,
        'notetype': notetype,
        'comment': comment
       };
      this.noteService.updateNotes(this.addData);
      if(tab=='landscape'){
        this.slNewNote = "";
        this.editor.txt.clear();
      }else if(tab=='healthView'){
        this.hvNewNote = "";
        this.editor.txt.clear();
      }else if(tab=='general'){
        this.geNewNote = "";
        this.editor.txt.clear();
      }
    }
    }
  }
  deleteNote(data){
    const dialogRef = this.dialog.open(OKCancelDialog, {
      width: '350px',
      data: {title:"Confirm", text: "Do you want to delete this note?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result=="ok"){
        this.noteService.deleteNote(data);
      }      
    });
  }
  save(tab):void {  
    this.checkAndSaveNotes();
    let saveData = {...this.data}
    // clean up and sort out nulls
    if(saveData["areaCounts"]) delete saveData["areaCounts"];
    if(saveData["selectedTab"]) delete saveData["selectedTab"];
    if(saveData["dorder"]) delete saveData["dorder"];
    // if the area has changed then remove the originalDisplayOrder so it is treated as new
    if(saveData["area"]!=this.originalArea) delete saveData["originalDisplayOrder"]

    if (saveData['yearslost']) {
      saveData['yearslost'] = moment(saveData['yearslost']).format(FORMAT);
    }
    if (saveData['servicetenure']) {
      saveData['servicetenure'] = moment(saveData['servicetenure']).format(FORMAT);
    }
    delete saveData['yearslostNum'];
    delete saveData['servicetenureNum'];

    delete saveData['useNewLayout'];

    Object.keys(saveData).forEach(x => {
      if(saveData[x]==null) saveData[x] = "";
    })
    
    if(tab=="bottom"){
      delete saveData["entitiesData"];
      delete saveData["sAccount"];
      delete saveData["sVersion"];
      this.dialogRef.close(saveData);
    }else{
      this.saveEntityAndNotes(saveData, tab);
    }
  }
  checkAndSaveNotes(){
    if(this.slNewNote&&this.slNewNoteDisplay){
      if(this.data.id){
        this.saveNote('landscape');
      }else{
        if(this.data['area']){
          this.data['slNewNote'] = this.slNewNote;
        } 
      }
    }
    if(this.hvNewNote&&this.hvNewNoteDisplay){
      if(this.data.id){
        this.saveNote('healthView');
      }else{
        if(this.data['area']){
          this.data['hvNewNote'] = this.hvNewNote;
        } 
      }
    }
    // if(this.geNewNote&&this.geNewNoteDisplay){
    //   if(this.data.id){
    //     this.saveNote('general');
    //   }else{
    //     if(this.data['area']){
    //       this.data['geNewNote'] = this.geNewNote;
    //     } 
    //   }
    // }
    if(this.landscapeView.length>0){
      if(this.landscapeView[this.landscapeView.length-1]["isEdit"]&&this.landscapeView[this.landscapeView.length-1]["newNote"]&&this.landscapeView[this.landscapeView.length-1]["saveBtDisplay"]){
        this.updateNote(this.landscapeView[this.landscapeView.length-1]);
      }
    }
    if(this.healthView.length>0){
      if(this.healthView[this.healthView.length-1]["isEdit"]&&this.healthView[this.healthView.length-1]["newNote"]&&this.healthView[this.healthView.length-1]["saveBtDisplay"]){
        this.updateNote(this.healthView[this.healthView.length-1]);
      }
    }
    if(this.allViews.length>0){
      this.allViews.forEach(x => {
        if(x["isEdit"]&&x["newNote"]&&x["saveBtDisplay"]){
          this.updateNote(x);
        }
      });
    }
  }
  saveEntityAndNotes(result, tab){
    let slNewNote = result['slNewNote'];
        let hvNewNote = result['hvNewNote'];
        let geNewNote = result['geNewNote'];
        if(result["slNewNote"]) delete result["slNewNote"]; 
        if(result["hvNewNote"]) delete result["hvNewNote"];
        if(result["geNewNote"]) delete result["geNewNote"];

        this.entitiesData = result.entitiesData;
        delete result["entitiesData"];
        result["accountid"] = result.sAccount["id"];
        delete result["sAccount"];
        result["versionid"] = result.sVersion;
        delete result["sVersion"];

        // save to the database
        this.entityService.updateEntity(result).then(
          (res:object) => { 
            if(slNewNote&&tab=='landscape'){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'landscape',
                'comment': slNewNote
              });
              this.slNewNote = "";
              this.editor.txt.clear();
            }
            if(hvNewNote&&tab=='healthView'){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'health',
                'comment': hvNewNote
              });
              this.hvNewNote = "";
              this.editor.txt.clear();
            }
            if(geNewNote&&tab=='general'){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'general',
                'comment': geNewNote
              });
              this.geNewNote = "";
              this.editor.txt.clear();
            }
          },
          (err) => { alert(err);}
        );

        // redo the order list for this area - remember the vals so we can save
        let updateSort = [];
        let cnt = 1;
        let newdo = result["displayorder"];
        let originaldo = result["originalDisplayOrder"]!=undefined ? result["originalDisplayOrder"] : 9999 ;
        // console.log("newdo:" + newdo + " originaldo:" + originaldo)
        this.entitiesData.sort((x, y) => (x.displayorder > y.displayorder) ? 1 : -1).forEach((x) => {
          if(x.area == result["area"]){
            if(x.id != result["id"]){
              if(x.displayorder < originaldo && x.displayorder >= newdo){
                // console.log("--udpate " + x.servicename + " to:" + ((+x.displayorder) + 1))
                x.displayorder = (+x.displayorder) + 1
                this.entityService.updateEntitySortOrder(x.id,x.displayorder);
                updateSort.push({accountid:result["accountid"],versionid:result["versionid"],id:x["id"],displayorder:x.displayorder})
              } else if (x.displayorder > originaldo && x.displayorder <= newdo) {
                // console.log("--udpate " + x.servicename + " to:" + ((+x.displayorder) - 1))
                x.displayorder = (+x.displayorder) - 1
                this.entityService.updateEntitySortOrder(x.id,x.displayorder);
                updateSort.push({accountid:result["accountid"],versionid:result["versionid"],id:x["id"],displayorder:x.displayorder})
              }
            }
          }
        });

        if(updateSort.length>0){
          this.entityService.updateEntitySort(updateSort);
        }
  }
  selectType(type){
    this[type] = !this[type];
    let selectedType=[];
    let checkedType = "";
    if(this.slSelected){
      selectedType.push('landscape');
      if(type=='slSelected'){
        checkedType = 'landscape';
      }
    }
    if(this.hvSelected){
      selectedType.push('health');
      if(type=='hvSelected'){
        checkedType = 'health';
      }
    }
    // if(this.geSelected){
    //   selectedType.push('general');
    // }
    this.selectedViews = this.allViews.filter(x => (selectedType.indexOf(x.notetype)!=-1));
    if(this.selectedViews.length>0&&this[type]){
      this.selectedViews.forEach(x => {
        if(x.notetype == checkedType){
          this.updateEditor(x, 'note'+x.id);
        }
      });
    }
  }

      // deep copy of Object
      public deepCopy(obj) {
        return Object.keys(obj).reduce((v, d) => Object.assign(v, {
          [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
        }), {});
      }

      private deepCopyArray(arr){
        let narray = [];
        arr.forEach(el => {
          narray.push(this.deepCopy(el))
        });
        return narray
      }

      initRichText(elementId, bindValue){
        this.editor = new E('#'+elementId);
          this.editor.config.height = 74
          this.editor.config.zIndex = 1049
          this.editor.i18next = i18next
          this.editor.config.lang = 'en'
          this.editor.config.menus = [
            'head',
            'bold',
            'fontSize',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'foreColor',
            'backColor',
            'link',
            'list',
            'table'
        ]
          this.editor.config.onchange = (newHtml) => {
            this[bindValue] = newHtml;
            let newVal = this.editor.txt.text().replace(/\s*/g,"");
            if(newVal.replace(/&nbsp;/gi, "") == ""){
              this[bindValue+'Display'] = false;
            }else{
              this[bindValue+'Display'] = true;
            }
          };
          this.editor.create();
          this.editor.txt.html(this[bindValue] || '');
      }

      ngAfterViewInit():void{
        if(this.data.selectedTab == 0){
          this.initRichText("addSlNote", "slNewNote");
        }else if(this.data.selectedTab == 1){
          this.initRichText("addHvNote", "hvNewNote");
        }
      }

      eidtLatestNote(note, elementId){
        if(!note["isEdit"]){
          note["isEdit"] = true;
          note["newNote"] = note.comment;
          note['saveBtDisplay'] = true;
        }
        this.updateEditor(note, elementId);
      }

      updateEditor(note, elementId){
        if(note["isEdit"] == true){
          setTimeout(()=>{
            this.editor1 = new E('#'+elementId);
            this.editor1.config.height = 44
            this.editor1.config.zIndex = 1049
            this.editor1.i18next = i18next
            this.editor1.config.lang = 'en'
            this.editor1.config.menus = [
              'head',
              'bold',
              'fontSize',
              'italic',
              'underline',
              'strikeThrough',
              'indent',
              'foreColor',
              'backColor',
              'link',
              'list',
              'table'
          ]
            this.editor1.config.onchange = (newHtml) => {
              note.newNote = newHtml;
              let newVal = this.editor1.txt.text().replace(/\s*/g,"");
              if(newVal.replace(/&nbsp;/gi, "") == ""){
                note['saveBtDisplay'] = false;
              }else{
                note['saveBtDisplay'] = true;
              }
            };
            this.editor1.create();
            this.editor1.txt.html(note.newNote || '');
          }, 100)
        }
      }
      updateNote(note){
        if(note.newNote==""){
          let message="The empty note could not be saved."
          let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        }else{
          this.addData = {
            'id':note.id, //(- 新增 ，其他数字为修改)
            'entityid': this.data.id,
            'versionid': this.data.versionid,
            'notetype': note.notetype,
            'comment': note.newNote
          };
          this.noteService.updateNotes(this.addData);
          note.isEdit = false;
        }
      }

      cancelUpdate(note){
        note.isEdit = false;
        note.newNote = "";
        // const dialogRef = this.dialog.open(OKCancelDialog, {
        //   width: '350px',
        //   data: {title:"Confirm", text: "Are you sure cancel the update?"}
        // });
    
        // dialogRef.afterClosed().subscribe(result => {
        //   if(result=="ok"){
        //     note.isEdit = false;
        //     note.newNote = "";
        //   }      
        // });
      }

      tabChange(event) {
        let selectedTab = event.tab.textLabel;
        if(selectedTab == "Service Landscape"){
          this.initRichText("addSlNote", "slNewNote");
          if(this.landscapeView.length>0){
            this.updateEditor(this.landscapeView[this.landscapeView.length-1], 'latestSlNote');
          }
        }else if(selectedTab == "Health View"&&(this.data.id||this.data['area'])){
          this.initRichText("addHvNote", "hvNewNote");
          if(this.healthView.length>0){
            this.updateEditor(this.healthView[this.healthView.length-1], 'latestHvNote');
          }
        }else if(selectedTab == "All Notes"&&(this.data.id||this.data['area'])){
          if(this.selectedViews.length>0){
            this.selectedViews.forEach(x => {
              this.updateEditor(x, 'note'+x.id);
            });
          }
        }        
      }

      getNoteColor(note){
     
        if(note.notetype=="landscape") return "#FFC000"
        if(note.notetype=="health") return "#92D050"
        if(note.notetype=="general") return "#33CCFF"
     
         return ""    
       }

  toggleDatePicker(field: string) {
    this[field] = !this[field];
  }

  changeYearInput(field: string) {
    const numField = `${field}Num`;
    if (this.data[numField]) {
      const years = Number(this.data[numField]);
      const oriYears = Number(this[numField]);
      if (years === oriYears && this[field]) {
        this.data[field] = this[field];
      } else {
        this.data[field] = moment(new Date()).add(-years, 'years').format();
      }
    } else {
      this.data[field] = '';
    }
  }

  changeDatePicker(field: string, event: MatDatepickerInputEvent<Date>) {
    const numField = `${field}Num`;
    if (event.value && this.datePickerFilter(event.value)) {
      const currentYear = (new Date()).getFullYear();
      const dateYear = (new Date(event.value)).getFullYear();
      this.data[numField] = `${currentYear - dateYear}`;
    } else {
      this.data[field] = '';
      this.data[numField] = '';
    }
  }

  datePickerFilter = (d: Date | null): boolean => {
    const dateYear = (new Date(d || new Date())).getFullYear();
    const currentYear = (new Date()).getFullYear();
    const diff = currentYear - dateYear;
    return diff >= 0 && diff <= this.maxYearDiff;
  }

  triggerEntityOnChanges() {
    this.data = Object.assign({}, this.data);
  }
}



// TODO - put this as a seperate component - bound to need it
@Component({
  selector: 'okcanceldialog',
  styleUrls: ['./entity-edit.component.scss'],
  template: `<h3 class="mat-dialog-title aip-dialog-title">{{data.title}}</h3>
  <div class="mat-dialog-content aip-dialog-text">
    {{data.text}}
</div>
  <div class="mat-dialog-actions" align="end">
    <button class="mat-focus-indicator aip-button mat-raised-button mat-button-base mat-primary" (click)="ok()">OK</button>
    <button class="mat-focus-indicator aip-button-alt mat-raised-button mat-button-base" (click)="cancel()" cdkFocusInitial>Cancel</button>
</div>
    `
})
export class OKCancelDialog {

  constructor(
    public dialogRef: MatDialogRef<OKCancelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ok(): void {
      this.dialogRef.close("ok");
    }

  cancel(): void {
    this.dialogRef.close("cancel");
  }


}
